module.exports = __webpack_public_path__ + "img/banner7.c4d351ee.png";